<template>
    <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
        <div class="main">
            <!-- <div @click="redirectPreviousUrl" style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
        <p>
            <a-icon type="double-left" />
        </p> 
        <p>Go Back </p> 
        
    </div> -->
            <div class=actions>
                <h3 style="font-size: 28px; line-height: 45px">Payments</h3>
                <div>
                    <a-button @click="paymentModalVisible = true" style="background: #fff;color:#0F3659" icon="plus"
                        class="mr-4">
                        Add New Payment
                    </a-button>
                    <a-button :loading="loading" @click="exportExcell"
                        style="border-raduis:6px; background: #fff;color:#0F3659" icon="export">
                        Export
                    </a-button>
                </div>
            </div>


            <div class="mt-5">
                <payments-table :payments="tableAllPayments"></payments-table>
            </div>
        </div>
        <a-modal :width="800" :visible="paymentModalVisible" :footer="null" @cancel="handlePaymentVisibleCancel">
            <add-new-payment-form @closeModal="paymentModalVisible = false"></add-new-payment-form>
        </a-modal>
    </a-card>

</template>

<script>

import moment from 'moment';
// import _ from 'lodash';
import XLSX from "xlsx";
import { mapActions } from 'vuex';
import AddNewPaymentForm from './modals/AddNewPaymentForm.vue';

import { NotificationMixins } from '@/mixins/NotificationMixins'
import PaymentsTable from "./tables/PaymentsTable.vue"



const tablePurchaseOrders = [
    {
        id: 1,
        key: 1,
        numberOfItems: 10,
        cretaedBy: 'Divine Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Draft',
        action: {
            id: 1,
            key: 1,
            numberOfItems: 10,
            cretaedBy: 'Divine Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Draft'
        }
    },
    {
        id: 2,
        key: 2,
        numberOfItems: 34,
        cretaedBy: 'Divine Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Draft',
        action: {
            id: 2,
            key: 2,
            numberOfItems: 34,
            cretaedBy: 'Divine Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Draft'
        }
    },
    {
        id: 3,
        key: 3,
        numberOfItems: 24,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Pending',
        action: {
            id: 3,
            key: 3,
            numberOfItems: 24,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Pending'
        }
    },
    {
        id: 4,
        key: 4,
        numberOfItems: 45,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Completed',
        action: {
            id: 4,
            key: 4,
            numberOfItems: 45,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Completed'
        }
    },
    {
        id: 5,
        key: 5,
        numberOfItems: 45,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Cancelled',
        action: {
            id: 5,
            key: 5,
            numberOfItems: 45,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Cancelled'
        }
    },
    {
        id: 6,
        key: 6,
        numberOfItems: 45,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Receiving',
        action: {
            id: 6,
            key: 6,
            numberOfItems: 45,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Receiving'
        }
    },
    
]

    export default {
        name: "PurchaseOrderHistory",
        components:{
            PaymentsTable,
            AddNewPaymentForm
        },
        data(){
            return{
                tableAllPayments: [],
                tablePendingInvoices: [],
                tablePendingPurchaseOrders: [],
                tablePartiallyPaidInvoice: [],
                tablePaidInvoices:[],
                tableOverdueInvoice: [],
                tableCriticalOverdue:[],
                tableCancelledInvoice:[],
                availableInvoices: [],
                tablePurchaseOrders,
                loading: false,
                paymentModalVisible: false,
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
            }
        },
        mixins: [ NotificationMixins ],
        methods:{
            ...mapActions(['addStockToWarehouse',]),
            redirectPreviousUrl(){
                this.$router.back()
            },  
            exportExcell(){
                const dataToExport = [
                    [
                        "Date",
                        "Payment #D",
                        "Invoice #",
                        "Reference #",
                        "Payment Mode",
                        "Payment Type",
                        "Amount Received(Ksh)",
                        "Unused Amount(Ksh)"
                    ],
                ];
                
            
                this.tableAllPayments.forEach((v) => {
                        dataToExport.push([
                            v.createdAt,
                            v.id,
                            v.invoiceId ? v.invoiceId : "N/A",
                            v.reference ? v.reference : "N/A",
                            v.paymentMode ? v.paymentMode : "N/A",
                            v.paymentMethod ? v.paymentMethod : "N/A",
                            v.amountReceived ? v.amountReceived : "N/A",
                            v.unusedAmount? v.unusedAmount : "N/A"
                        ]);
                });

                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(dataToExport);

                /* Add the worksheet to the workbook */
                XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                /* generate file and send to client */
                XLSX.writeFile(wb, `Payment-Invoice-${moment().format('DD-MM-YYYY')}.xlsx`);
                this.showSuccessAlert("Data Successfully Exported")
            },

            onInvoiceChange(value){

                let result = []
                if(value == "all"){
                    result = this.availableInvoices;
                }else{
                    result = this.availableInvoices.filter(invoice => parseInt(invoice.status) === parseInt(value) )
                }
                this.tableAllInvoices = result.map(invoice => ({
                        key: invoice.id,
                    id: invoice.id,
                    createdAt: moment(invoice.createdAt).format("DD-MM-YYYY"),
                        totalOrderValue: invoice.totalOrderValue ? invoice.totalOrderValue.toLocaleString(undefined,{minimumFractionDigits: 2}) : '0.00',
                        customerName: invoice.customerName,
                        statusLabel: invoice.invoiceStatusTypeLabel,
                        action: invoice
                    }))
            },

            getAllPaymentsData(response) {
                if (response.status === 200) {
                    this.tableAllPayments = response.data.data.map(payment => ({
                        key: payment.id,
                        id: payment.id,
                        invoiceId: payment.invoiceId ? payment.invoiceId : "N/A",
                        orderTypeLabel: payment.orderTypeLabel,
                        reference: payment.reference ? payment.reference : "N/A",
                        paymentType: payment.paymentType ? payment.paymentType : "N/A",
                        paymentMode: payment.paymentMode ? payment.paymentMode : "N/A",
                        amountReceived: payment.amount ? payment.amount : "N/A",
                        unusedAmount: payment.unusedAmount ? payment.unusedAmount : "N/A",
                        primaryCost: payment.primaryCost,
                        otherCost: payment.otherCost,
                        totalCost: payment.totalCost,
                        paymentMethod: payment.transactionMethodLabel,
                        createdAt: moment(payment.createdAt).format('DD-MM-YYYY HH:mm:ss'),
                        action: payment
                    }))
                }else{
                    // console.log("Error | ", response)
                }
            },

            handlePaymentVisibleCancel() {
                this.paymentModalVisible = false
            },

            async orderData(data){
                if (data) {
                    this.loadInvoices();
                }  
            },

            invoiceStatus(data){
                if(data){
                    this.loadInvoices();
                }
            },
            async orderStatus(request_body) {
                const response = await this.$store.dispatch("purchaseOrder/updatePurchaseOrderStatus",request_body, { root: true} )
                if (response.status === 200) {
                    this.showSuccessAlert('Purchase Order Updated Successfully');
                    this.loadInvoices()
                } else {
                    this.showErrorAlert('Something went wrong');
                }
            },

            async loadPayments(){
                this.loading = true;   
                const response = await this.$store.dispatch('payments/getPayments');
                this.loading = false;
                this.getAllPaymentsData(response)
            }
        },
        created(){
            if(this.loadPayments){
                this.loadPayments()
            }
        } 
}
</script>

<style scoped>
.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container
  >>> .ant-tabs.ant-tabs-card
  .ant-tabs-card-bar
  .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.card-container >>> .ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
  border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
  border-top: none;
}
.modalStyle {
  display: flex;
  justify-content: center;
}

.card-container >>> .ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.spinner >>> .ant-spin-dot-item {
  background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}


</style>